Shopify.onError = function(error) {
	alert('Error: ' + error.message);
}

Shopify.onCartUpdate = function(cart) {
	jQuery('#cart-total').html(Shopify.formatMoney(cart.total_price));
    jQuery('#minicart-quantity').html(cart.item_count);
    jQuery('#cart-items').empty();
    if(cart.items.length > 0){
      jQuery.each(cart.items, function(key, item) {
        itemDiv					  = jQuery(document.createElement('li'));
        itemDiv.context.className = 'cart-item';
        itemDiv.context.id        = 'item-'+item.variant_id;
        if(item.image) {
          itemDiv.context.innerHTML = '<img onError=\"this.style.display = \'none\';\" src=\"' + Shopify.resizeImage(item.image, 'compact') + '\" alt=\"' + item.title + '\" width="141" />';
        }
        itemDiv.context.innerHTML = itemDiv.context.innerHTML + '<div class="text-holder">' + '<h2><a href=\"'+item.url+'\">' + truncateString(item.title, 18) + '</a></h2>' +
          ' <span class="price"><strong>FROM</strong>'+ Shopify.formatMoney(item.line_price) +'</span></div>';
        jQuery('#cart-items').append(itemDiv);
      });
      jQuery("#minicart-content").show();
    }
}  

function truncateString(str, length) {
  return str.length > length ? str.substring(0, length - 3) + '...' : str
}

Shopify.onItemAdded = function(line_item) { 
	Shopify.getCart(function(cart){
		Shopify.onCartUpdate(cart);
	});
}

var Showroom = {
      onVariantChange: function(select) {
      },
      updatePrice: function(product_id) {
          var field = jQuery('#product-quantity-'+product_id).val();
          var variant_price = jQuery('#price-'+product_id).val();
          var variant_compare_price = jQuery('#price-compare-'+product_id).val();
          if(variant_price < variant_compare_price){
            var price = Shopify.formatMoney(variant_price * field) + " <del>" + Shopify.formatMoney(variant_compare_price * field) + "</del>";
          } else {
            var price = Shopify.formatMoney(variant_price * field);
          }
          price = price.replace(' ', '');
          jQuery('#price-field-'+product_id).html(price);
      }
  }